require('./dist/manifest');
require('./dist/vendor');
module.exports = require('./dist/index').default;


//////////////////
// WEBPACK FOOTER
// ./~/react-custom-audio-player/index.js
// module id = 69
// module chunks = 0